import { render, staticRenderFns } from "./Analise.vue?vue&type=template&id=1c88cb31"
import script from "./Analise.vue?vue&type=script&lang=js"
export * from "./Analise.vue?vue&type=script&lang=js"
import style0 from "./Analise.vue?vue&type=style&index=0&id=1c88cb31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports